export const LANGUAGE_API = {
  ENGLISH: 'EN',
  NORWEGIAN: 'NB',
} as const;

export const LANGUAGE_I18N = {
  ENGLISH: 'en',
  NORWEGIAN: 'no',
} as const;

export const URL_PARAM_LANGUAGE = 'language';

export type ApiLanguage = typeof LANGUAGE_API[keyof typeof LANGUAGE_API];
export type I18nLanguage = typeof LANGUAGE_I18N[keyof typeof LANGUAGE_I18N];
